const UserIdentitySummary = ({ showRole = true, user }) => {
  const normalizedUser = user || {}

  return (
    <span className="user-identity-summary">
      <strong className="user-identity-summary__name">
        {normalizedUser.name || 'Unknown user'}
      </strong>
      <span className="user-identity-summary__identity">
        {normalizedUser.email || 'No email'}
        {normalizedUser.login_id && ` · ${normalizedUser.login_id}`}
      </span>
      {showRole && (
        <span className="user-identity-summary__role">
          {normalizedUser.title || 'Target team member'}
        </span>
      )}
    </span>
  )
}

export default UserIdentitySummary
